import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { LanguageProvider } from "./LanguageContext";  // 🔹 NEW

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <LanguageProvider>
        <App />
    </LanguageProvider>
);

// If you want to start measuring performance...
reportWebVitals();





